import styled from "styled-components";

const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 2rem;
`;

const Btn = styled.button`
  padding: 0.375rem 1rem;
  border-radius: ${({ theme }) => theme.radius.full};
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  background: ${({ $on, theme }) =>
    $on ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.card})`};
  color: ${({ $on, theme }) =>
    $on ? `hsl(${theme.colors.primaryForeground})` : `hsl(${theme.colors.foreground})`};
  &:hover {
    background: ${({ $on, theme }) =>
      $on ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.muted})`};
  }
`;

export default function StoresCategoryChips({
  categories = [],
  selectedCategory,
  onSelect,
}) {
  const chips = categories.length ? categories : ["All"];

  return (
    <Wrap>
      {chips.map((cat) => (
        <Btn
          key={cat}
          type="button"
          $on={selectedCategory === cat}
          onClick={() => onSelect(cat)}
        >
          {cat}
        </Btn>
      ))}
    </Wrap>
  );
}
